import { render, staticRenderFns } from "./AllTimeTopGainers.vue?vue&type=template&id=40aa20e3&"
import script from "./AllTimeTopGainers.vue?vue&type=script&lang=js&"
export * from "./AllTimeTopGainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports